{{ runChangeDetection
}}<!--{{this.messageBody.offsetWidth}}{{isAvatar}}--{{messagesContainer.clientWidth - ((12.6 * 2) * (this.lvl - 1))}}--{{lvl}}--->
<div
  #attachmentWrap
  *ngIf="message?.attachments?.length > 0"
  [class.d-flex]="isGallery"
  [class.attachments-gallery]="isGallery"
  class="flex-wrap message-attachments pb-3"
>
  <ng-container
    *ngFor="let attachment of message.attachments || []; trackBy: trackByFn"
    [ngSwitch]="attachment.type"
    class=""
  >
    <ng-template ngSwitchCase="document">
      <div
        [ngStyle]="{
          width: attachment?.thumb?.width + 'px',
          height: attachment?.thumb?.height + 'px'
        }"
        class="gallery-item position-relative"
        *ngIf="isGallery; else docFull"
        [class.document-gallery-nophoto]="!attachment.thumb?.file_uri"
      >
        <span
          [title]="attachment.file_name"
          *ngIf="attachment?.thumb?.width > 190"
          class="desc-line center-desc-line top-desc-line text-truncate"
        >
          {{ attachment.file_name || allService.basename(attachment?.file_uri || '', '') }}
        </span>
        <a
          [href]="attachment.file_uri"
          (click)="downloadFile($event, attachment)"
          rel="noopener"
          target="_blank"
          class="d-block h-100 square-center position-relative"
        >
          <app-icon-mime [mime]="attachment.mime_type" class="mr-5"></app-icon-mime>
          <img
            loading="lazy"
            *ngIf="attachment.thumb?.file_uri"
            (error)="loadImageAttachmentError($event, attachment)"
            [src]="attachment.thumb.file_uri"
            class="w-100 h-100 rounded pointer img-fluid"
          />
        </a>
        <span *ngIf="attachment.file_size_convert" class="desc-line center-desc-line bottom-desc-line text-truncate">{{
          attachment.file_size_convert
        }}</span>
      </div>

      <ng-template #docFull>
        <div class="d-block w-100 gallery-w-100 card shadow-sm pointer text-decoration-none mb-3">
          <div (click)="downloadFile($event, attachment)" class="card-body p-3 media">
            <app-icon-mime [mime]="attachment.mime_type" class="mr-5"></app-icon-mime>
            <svg
              class="radial-progress invert"
              width="42"
              height="42"
              [attr.data-percentage]="4.4 * attachment?.downloadInfo?.progress || 0"
              viewBox="0 0 80 80"
            >
              <circle class="incomplete" cx="40" cy="40" r="35"></circle>
              <circle
                class="complete"
                cx="40"
                cy="40"
                r="35"
                [style.stroke-dasharray]="(4.4 * attachment?.downloadInfo?.progress || 0) + ', 100'"
              ></circle>
            </svg>
            <div class="media-body text-dark overflow-hidden flex-fill">
              <span [title]="attachment.file_name" class="d-block text-truncate font-medium text-reset">
                <span *ngIf="attachment.file_name?.length <= 17; else shortDocName">{{ attachment.file_name }}</span>
                <ng-template #shortDocName>{{ attachment.file_name.substring(0, 17) }}...</ng-template>
              </span>
              <ul class="list-inline small mb-0 mt-2 d-flex flex-wrap">
                <li class="list-inline-item">
                  <span class="t">{{ attachment.file_size_convert }}</span>
                </li>
                <li [title]="attachment.mime_type" *ngIf="attachment.mime_type?.length < 25" class="list-inline-item">
                  <span class="text-uppercase text-truncate d-block">{{ attachment.mime_type }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="mx-auto"
            *ngIf="attachment.thumb"
            [ngStyle]="{
              width: attachment?.thumb?.width + 'px',
              height: attachment?.thumb?.height + 'px',
              'max-width': '100%'
            }"
          >
            <div
              *ngIf="!attachment.thumb.file_uri; else documentThumb"
              class="d-flex h-100 flex-column justify-content-center align-items-center text-center"
            >
              <i-feather
                *ngIf="!attachment.thumb?.file_uri_error; else errorImage"
                class="icon-xxl"
                name="image"
              ></i-feather>
            </div>
            <ng-template #documentThumb>
              <img
                loading="lazy"
                (click)="downloadFile($event, attachment)"
                (error)="loadImageAttachmentError($event, attachment)"
                [src]="attachment.thumb.file_uri"
                class="rounded mb-4 pointer img-fluid"
              />
            </ng-template>
          </div>
        </div>
      </ng-template>
    </ng-template>
    <ng-template ngSwitchCase="video_note">
      <app-video-player
        [Service]="Service"
        [attachment]="attachment"
        [caption]="message.text"
        [styles]="{ width: '250px', height: '250px' }"
        [round]="true"
        [vizible]="true"
        class="d-block"
      ></app-video-player>
    </ng-template>
    <ng-template ngSwitchCase="animation">
      <app-video-player
        [Service]="Service"
        [attachment]="attachment"
        [caption]="message.text"
        [styles]="{
          width: attachment?.thumb?.width + 'px',
          height: 'auto',
          'min-height': attachment?.thumb?.height + 'px'
        }"
        [vizible]="true"
        class="d-block"
      ></app-video-player>
    </ng-template>
    <ng-template ngSwitchCase="video">
      <app-video-player
        [Service]="Service"
        [attachment]="attachment"
        [caption]="message.text"
        [styles]="{
          width: attachment?.thumb?.width + 'px',
          height: 'auto',
          'min-height': attachment?.thumb?.height + 'px'
        }"
        [vizible]="true"
        class="d-block"
      ></app-video-player>
    </ng-template>
    <ng-template ngSwitchCase="photo">
      <div
        class="gallery-item"
        *ngIf="attachment.thumb"
        [ngStyle]="{
          width: attachment?.thumb?.width + 'px',
          height: attachment?.thumb?.height + 'px',
          'max-width': '100%'
        }"
      >
        <a
          (click)="galleryService.openGallery($event, attachment.file_uri)"
          [attr.data-caption]="message.text"
          [href]="attachment.file_uri"
          class="d-block h-100"
          data-fancybox="gallery"
          rel="noopener"
          target="_blank"
        >
          <div
            *ngIf="!attachment.thumb.file_uri; else photoThumb"
            class="d-flex h-100 flex-column justify-content-center align-items-center text-center"
          >
            <i-feather
              *ngIf="!attachment.thumb?.file_uri_error; else errorImage"
              class="icon-xxl"
              name="image"
            ></i-feather>
          </div>
          <ng-template #photoThumb>
            <img
              loading="lazy"
              (error)="loadImageAttachmentError($event, attachment)"
              [src]="attachment.thumb.file_uri"
              class="rounded mb-4 pointer img-fluid"
            />
          </ng-template>
        </a>
      </div>
    </ng-template>
    <ng-template ngSwitchCase="audio">
      <app-message-player
        class="gallery-w-100"
        [Service]="Service"
        [attachment]="attachment"
        [reverse]="!message.out"
      ></app-message-player>
    </ng-template>
    <ng-template ngSwitchCase="web_page">
      <!--<div *ngIf="attachment.full_width; else compactWebPage">
        <div *ngIf="attachment.thumb; else iconWebThumb" class="mr-3">
          <a [href]="attachment.url" [ngStyle]="{'width': attachment?.thumb?.width + 'px', 'height': 'auto', 'min-height': attachment?.thumb?.height +'px'}"
             class="d-block" rel="noopener" target="_blank">
            <div *ngIf="!attachment.thumb.file_uri; else webThumb"
                 class="d-flex h-100 flex-column justify-content-center align-items-center text-center">
              <i-feather *ngIf="!attachment.thumb?.file_uri_error; else errorImage" class="icon-xxl text-white" name="image"></i-feather>
            </div>
          </a>
        </div>
      </div>-->
      <!-- compact -->
      <!-- <ng-template #compactWebPage>-->
      <div class="shadow-sm card text-dark w-100 gallery-link gallery-w-100 mb-3">
        <div class="card-body p-3 media">
          <div *ngIf="attachment.thumb; else iconWebThumb" class="mr-3">
            <a
              [href]="attachment.url"
              [ngStyle]="{ width: '50px', height: 'auto', 'min-height': '50px' }"
              class="d-block"
              rel="noopener"
              target="_blank"
            >
              <div
                *ngIf="!attachment.thumb.file_uri; else webThumb"
                class="d-flex h-100 flex-column justify-content-center align-items-center text-center"
              >
                <i-feather
                  *ngIf="!attachment.thumb?.file_uri_error; else errorImage"
                  class="icon-xxl text-white"
                  name="image"
                ></i-feather>
              </div>
            </a>
          </div>
          <div class="media-body text-dark overflow-hidden flex-fill">
            <a [href]="attachment.url" class="text-dark text-decoration-none" rel="noopener" target="_blank">
              <span [title]="attachment.title || attachment.url" class="d-block text-truncate font-medium text-reset">{{
                attachment.title || attachment.url
              }}</span>
              <ul class="list-inline small mb-0 mt-2 d-flex flex-wrap">
                <li class="list-inline-item media-subtitle">
                  <span>{{ attachment.description || 'Ссылка' }}</span>
                </li>
              </ul>
            </a>
          </div>
        </div>
      </div>
      <!-- </ng-template>-->
      <ng-template #iconWebThumb>
        <a [href]="attachment.url" class="icon-shape text-white mr-5" rel="noopener" target="_blank">
          <i-feather name="external-link"></i-feather>
        </a>
      </ng-template>
      <ng-template #webThumb>
        <img
          loading="lazy"
          (error)="loadImageAttachmentError($event, attachment)"
          [src]="attachment.thumb.file_uri"
          class="rounded img-fluid img-prev"
        />
      </ng-template>
    </ng-template>
    <ng-template ngSwitchCase="contact">
      <div
        (click)="
          modalService.openModal('ModalChatDetailComponent', {
            Service: Service,
            id: attachment.user_id,
            initData: attachment
          })
        "
        class="pointer card card-contact gallery-w-100"
      >
        <div class="card-body p-0">
          <div class="media">
            <div class="media-body overflow-hidden">
              <div class="d-flex align-items-center mb-1">
                <h6 class="text-truncate mb-0 mr-auto">
                  <span
                    *ngIf="attachment?.name?.first"
                    [innerHTML]="
                      attachment?.name?.first + ' ' + attachment?.name?.last | replaceEmojis: 'facebook':20:64
                    "
                  ></span>
                </h6>
              </div>
              <div>
                <a href="tel:{{ attachment.phone_number }}">{{ attachment.phone_number }}</a>
              </div>
              <small><i-feather name="message-square"></i-feather> Написать</small>
            </div>
            <app-avatar
              [id]="attachment.user_id"
              [type]="'private'"
              [avatar]="attachment.user.avatar"
              [avatarFileId]="attachment.user.avatar_file_id"
              [avatarFileUniqueId]="attachment.user.avatar_file_unique_id"
              class="avatar mr-5"
            ></app-avatar>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template ngSwitchCase="location">
      <div (click)="openMap($event, attachment)" class="attachments-geo square-center position-relative gallery-item">
        <span class="square-center-icon no-filter"><i-feather class="no-filter" name="map-pin"></i-feather></span>
        <a [href]="attachment.geo">
          <img
            loading="lazy"
            [ngStyle]="{
              width: attachment?.thumb?.width + 'px',
              height: attachment?.thumb?.height + 'px'
            }"
            [src]="attachment.thumb.file_uri"
          />
        </a>
      </div>
    </ng-template>
    <!-- VK -->
    <ng-template ngSwitchCase="video_iframe">
      <div class="gallery-item" (deferLoad)="videoIframeInit(attachment)">
        <iframe
          *ngIf="attachment.player && !attachment.thumb"
          [ngStyle]="{
            width: attachment?.width + 'px',
            height: attachment?.height + 'px'
          }"
          [src]="attachment.player"
          frameborder="0"
        ></iframe>
        <div
          [ngStyle]="{
            width: attachment?.thumb?.width + 'px',
            height: attachment?.thumb?.height + 'px'
          }"
          class="square-center position-relative"
          *ngIf="attachment.thumb"
          (click)="openIframeVideo(attachment)"
        >
          <span class="square-center-icon no-filter"><i-feather class="no-filter" name="video"></i-feather></span>
          <img
            loading="lazy"
            [class.img-cover]="attachment?.thumb?.cover"
            (error)="loadImageAttachmentError($event, attachment)"
            [src]="attachment.thumb.file_uri"
            class="rounded mb-4 pointer img-fluid"
          />
        </div>
      </div>
    </ng-template>
    <ng-template ngSwitchCase="gift">
      <div
        class="mx-auto gift-wrap"
        *ngIf="attachment.thumb"
        [ngStyle]="{
          width: attachment?.thumb?.width + 'px',
          height: attachment?.thumb?.height + 'px',
          'max-width': '100%'
        }"
      >
        <img
          loading="lazy"
          (error)="loadImageAttachmentError($event, attachment)"
          [src]="attachment.thumb.file_uri"
          class="rounded mb-4 pointer img-fluid"
        />
      </div>
    </ng-template>
    <ng-template ngSwitchCase="call">
      <div class="card">
        <div class="card-body p-3 media">
          <span class="icon-shape text-white bg-primary mr-5">
            <i-feather name="phone-call"></i-feather>
          </span>
          <div class="media-body text-dark overflow-hidden flex-fill">
            <div [innerHTML]="message.text_list" class="text-truncate font-medium text-reset"></div>
            <div class="text-muted small text-truncate font-medium text-reset">
              <div class="text-primary" *ngIf="message.attachments?.length > 1">
                Еще {{ message.attachments?.length - 1 }}
              </div>
              <div>Пока не поддерживается...</div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template ngSwitchCase="wall">
      <div class="wall-wrap gallery-w-100">
        <app-message-wall
          [Service]="Service"
          [class.message-right]="message.out"
          [message]="message"
          [wall]="attachment.wall"
          [messagesContainer]="messagesContainer"
          [messageBody]="messageBody"
          class="mb-2"
          [lvl]="lvl"
          id="wall-{{ attachment.wall.id }}"
        ></app-message-wall>
      </div>
    </ng-template>
  </ng-container>
</div>

<ng-template #errorImage>
  <div tooltip="Ошибка загрузки, нажмите, что бы повторить.">
    <i-feather class="icon-xxl" name="alert-octagon"></i-feather>
  </div>
</ng-template>
